var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"terminalFrame",staticClass:"terminalBlock",attrs:{"id":"terminalFrame","src":_vm.computeTerminalUrl},on:{"load":_vm.terminalLoad}}),_vm._v(" "),(!_vm.ready)?_c('div',{staticClass:"terminalBlock",attrs:{"id":"terminalCurtain"}},[_vm._v(" loading terminal... ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-446c3943","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notebook/Terminal.vue
// module id = vW9R
// module chunks = 1